import styled from 'styled-components';

export const Form = styled.form`
    width: 100%;
`;

export const Container = styled.div`
    width: 100%;
`;
